import React from 'react';
import HamburgerMenu from '../global/menu';
import { BRANDING } from '../config';
import '../global/styles.css';

// Station configurations for Walton
const STATIONS = [
  {
    id: 'station-1',
    name: 'Station 1 Complete Usage Accountability Form',
    label: 'Station 1',
    address: '12600 Towne Center Dr, Walton KY 41094',
    dea: 'FM2049547'
  },
  {
    id: 'station-2',
    name: 'Station 2 Complete Usage Accountability Form',
    label: 'Station 2',
    address: '261 Shorland Dr, Walton, KY 41094',
    dea: 'FM2049523'
  }
];

function AccountabilityHome({ userInfo, isAdmin, onLogout, onNavigate }) {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--background-color)', padding: '20px' }}>
      <HamburgerMenu
        isAdmin={isAdmin}
        onLogout={onLogout}
        onNavigate={onNavigate}
      />

      <div style={{ maxWidth: '800px', margin: '0 auto', paddingTop: '40px' }}>
        {/* Header */}
        <h1 style={{
          textAlign: 'center',
          color: 'var(--text-color)',
          fontSize: '28px',
          fontWeight: '600',
          marginBottom: '15px'
        }}>
          Station Complete Usage Accountability Forms
        </h1>

        <p style={{
          textAlign: 'center',
          color: 'var(--text-muted)',
          fontSize: '16px',
          marginBottom: '40px'
        }}>
          Select the appropriate station below to complete the accountability form.
        </p>

        {/* Station Cards */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          {STATIONS.map(station => (
            <div
              key={station.id}
              onClick={() => onNavigate(`accountability-form-${station.id}`)}
              style={{
                background: 'var(--card-background)',
                border: '1px solid var(--border-color)',
                borderRadius: '12px',
                padding: '20px 25px',
                cursor: 'pointer',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                transition: 'all 0.2s ease',
                boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                e.currentTarget.style.borderColor = BRANDING.primaryColor;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.05)';
                e.currentTarget.style.borderColor = 'var(--border-color)';
              }}
            >
              <div style={{ flex: 1 }}>
                <h3 style={{
                  color: 'var(--text-color)',
                  fontSize: '18px',
                  fontWeight: '600',
                  marginBottom: '10px'
                }}>
                  {station.name}
                </h3>
                <p style={{
                  color: 'var(--text-muted)',
                  fontSize: '14px',
                  lineHeight: '1.5',
                  margin: 0
                }}>
                  This form is to be completed ONLY in the event that the ENTIRE VIAL of above listed medication is ADMINISTERED TO THE PATIENT.
                </p>
              </div>
              <div style={{
                fontSize: '24px',
                color: 'var(--text-muted)',
                marginLeft: '20px'
              }}>
                {'>'}
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}

export { STATIONS };
export default AccountabilityHome;
